// Modelljämförelser — driver /jamfor/[a]-vs-[b].
// Kraftfullt SEO-verktyg: "X vs Y"-sökningar har hög köp­intention.

export interface Comparison {
  slug: string; // "rapido-v62-vs-rapido-v68"
  aName: string;
  bName: string;
  aBrand: string;
  bBrand: string;
  category: string;
  intro: string;
  winner: string; // kort mening om vem som passar vem
  rows: { label: string; a: string; b: string }[];
  aStrengths: string[];
  bStrengths: string[];
  verdict: string;
  faq: { q: string; a: string }[];
}

export const COMPARISONS: Comparison[] = [
  {
    slug: "rapido-v62-vs-rapido-v68",
    aName: "Rapido V62",
    bName: "Rapido V68",
    aBrand: "Rapido",
    bBrand: "Rapido",
    category: "Plåthusbil",
    intro:
      "V62 och V68 är Rapidos två populäraste plåthusbilar och skiljer sig egentligen bara i sängen bak — V62 har fransk säng (dubbelsäng), V68 har två längsgående enkelsängar. Val av säng styr resten.",
    winner:
      "Fransk säng (V62) om ni sover ihop och prioriterar förvaring. Enkelsängar (V68) om någon vaknar tidigt eller är lättstörd.",
    rows: [
      { label: "Längd", a: "640 cm", b: "636 cm" },
      { label: "Bredd", a: "205 cm", b: "205 cm" },
      { label: "Totalvikt", a: "3 500 kg (B-körkort)", b: "3 500 kg (B-körkort)" },
      { label: "Säng bak", a: "Fransk säng 195 × 150 cm", b: "2 enkelsängar 195 × 80 cm" },
      { label: "Garage", a: "Litet – under franska sängen", b: "Stort – mellan sängarna" },
      { label: "Pris ny", a: "Från 1 150 000 kr", b: "Från 1 200 000 kr" },
      { label: "Pris begagnad", a: "650 000–950 000 kr", b: "700 000–980 000 kr" },
    ],
    aStrengths: [
      "Sängen 150 cm bred — sov ihop",
      "Mer förvaring under sängen",
      "Något billigare begagnat",
    ],
    bStrengths: [
      "Två enkelsängar = bättre sömn om olika rytm",
      "Stort garage mellan sängarna — 2 elcyklar",
      "Går att koppla ihop till stor liggyta med mellandyna",
    ],
    verdict:
      "För par under 50: V62. För par som är över 55, går upp i olika tider eller vill kunna ta med elcyklar: V68 varje gång.",
    faq: [
      {
        q: "Kan man koppla ihop enkelsängarna i V68 till en dubbelsäng?",
        a: "Ja, med Rapidos tillbehör 'mellandyna' — sängarna blir en stor yta för mysstunder eller om barnbarn följer med. Vardagsfördelen med separata sängar är kvar.",
      },
      {
        q: "Hur mycket kortare räcker vattnet i V62 jämfört med V68?",
        a: "Ingen skillnad — båda har 100–120 l färskvatten och 90–100 l gråvatten. Räckvidd 2 personer: 3–5 dygn.",
      },
      {
        q: "Vilken håller värdet bäst begagnat?",
        a: "V68 tappar marginellt mindre — enkelsängar är populärare hos senior­marknaden som är den största köpar­gruppen begagnat.",
      },
    ],
  },
  {
    slug: "rapido-v55-vs-rapido-v62",
    aName: "Rapido V55",
    bName: "Rapido V62",
    aBrand: "Rapido",
    bBrand: "Rapido",
    category: "Plåthusbil",
    intro:
      "Enmeter kortare men samma bygg­kvalitet — V55 är för dig som prioriterar parkering och stads­körning. V62 för dig som vill ha komfort på långresor.",
    winner:
      "V55 för stads-/helgbruk och wildcamping i norr. V62 för dig som ska bo i bilen 2–6 månader per år.",
    rows: [
      { label: "Längd", a: "541 cm", b: "640 cm" },
      { label: "Bredd", a: "205 cm", b: "205 cm" },
      { label: "Totalvikt", a: "3 500 kg", b: "3 500 kg" },
      { label: "Kök", a: "2-låga kokplatta, 90 l kyl", b: "3-låga, 90–133 l kyl" },
      { label: "Våtrum", a: "Kompakt kombi", b: "Svängbar vägg – separat dusch" },
      { label: "Bränsleförbrukning", a: "0,9–1,1 l/mil", b: "1,0–1,2 l/mil" },
      { label: "Pris ny", a: "Från 1 050 000 kr", b: "Från 1 150 000 kr" },
      { label: "Pris begagnad", a: "550 000–850 000 kr", b: "650 000–950 000 kr" },
    ],
    aStrengths: [
      "1 meter kortare — parkerar överallt",
      "Lägre bränsleförbrukning",
      "Billigare i både inköp och drift",
    ],
    bStrengths: [
      "Riktigt kök med 3-låga",
      "Våtrum med separat dusch",
      "Bekvämare för långa vistelser",
    ],
    verdict:
      "V55 om ni är två som helgcampar och åker på 1–2 långa resor per år. V62 om husbilen ska vara hem 3+ månader.",
    faq: [
      {
        q: "Är V55 verkligen för trång för två i en månad?",
        a: "Det går, men kräver planering. Sittgruppen är även matbord och arbetsplats, du packar upp/ihop dagligen. På långresor väljer många ändå V62.",
      },
      {
        q: "Skiljer sig servicekostnaden mellan V55 och V62?",
        a: "Nej — samma Fiat/Citroën-chassi och samma Truma/Dometic-utrustning. Årlig service ligger på 6 000–10 000 kr för båda.",
      },
    ],
  },
  {
    slug: "rapido-v62-vs-adria-twin",
    aName: "Rapido V62",
    bName: "Adria Twin",
    aBrand: "Rapido",
    bBrand: "Adria",
    category: "Plåthusbil",
    intro:
      "Rapido V62 och Adria Twin är två av Europas mest sålda plåthusbilar för par. Rapido är franskt hantverk med lite premium­känsla; Adria är slovenska värde­riktad kvalitet.",
    winner:
      "Rapido V62 om budgeten tillåter och bygg­kvalitet väger tyngst. Adria Twin om priset styr.",
    rows: [
      { label: "Längd", a: "640 cm", b: "540–636 cm (flera versioner)" },
      { label: "Bredd", a: "205 cm", b: "205 cm" },
      { label: "Isolering", a: "35 mm PU + XPS", b: "25–30 mm XPS" },
      { label: "Vinterprestanda", a: "Bättre — dubblare isolering", b: "OK — bygger på sommarcamping" },
      { label: "Kök", a: "3-låga, 90–133 l kompressor", b: "3-låga, 84–90 l" },
      { label: "Värme", a: "Truma 4 eller 6 D (diesel)", b: "Truma 4 standard" },
      { label: "Pris ny", a: "Från 1 150 000 kr", b: "Från 850 000 kr" },
      { label: "Värdeminskning år 1", a: "Ca 15%", b: "Ca 20%" },
    ],
    aStrengths: [
      "Bättre isolering — vinterhusbil ur låda",
      "Litium/dieselvärme som stark tillvals­katalog",
      "Håller värdet mycket bra",
    ],
    bStrengths: [
      "300 000 kr billigare nytt",
      "Fler planlösningar att välja mellan",
      "Enklare service — utbrett återförsäljar­nät",
    ],
    verdict:
      "För norrländska förhållanden och långsiktig ekonomi: Rapido V62. För priskänslig sommarcamping: Adria Twin.",
    faq: [
      {
        q: "Håller Adria Twin lika bra som Rapido V62 begagnat?",
        a: "Nej — Rapido tappar långsammare tack vare stark efterfrågan och bättre byggkvalitet. Efter 5 år är prisskillnaden ny/ny betydligt mindre proportionellt.",
      },
      {
        q: "Kan Adria Twin köras på svensk vinter?",
        a: "Ja, ner till ca -10 °C komfortabelt. Vid -20 blir bilen påtagligt kall och avlopp kan frysa — då är Rapido med dubbla golv överlägsen.",
      },
    ],
  },
  {
    slug: "rapido-866f-vs-hymer-b-mc-t",
    aName: "Rapido 866F",
    bName: "Hymer B-MC T",
    aBrand: "Rapido",
    bBrand: "Hymer",
    category: "Halvintegrerad",
    intro:
      "Rapido 866F och Hymer B-MC T är två klassiska premium­halvintegrerade i samma storleks­klass — båda med franskt/tyskt kvalitets­rykte, dubbla golv och Alde-alternativ.",
    winner:
      "Rapido 866F för fransk finish och bättre inne­design. Hymer B-MC T för tysk teknik­robusthet och lägre begagnat­pris.",
    rows: [
      { label: "Längd", a: "749 cm", b: "699–749 cm" },
      { label: "Bredd", a: "232 cm", b: "223 cm" },
      { label: "Totalvikt", a: "3 500–4 250 kg", b: "3 500–4 500 kg" },
      { label: "Chassi", a: "Fiat AL-KO", b: "Fiat AL-KO / Mercedes" },
      { label: "Värme", a: "Truma Combi 6 / Alde", b: "Truma Combi 6 / Alde" },
      { label: "Dubbla golv", a: "Ja", b: "Ja" },
      { label: "Pris ny", a: "Från 1 550 000 kr", b: "Från 1 650 000 kr" },
      { label: "Pris begagnad", a: "750 000–1 250 000 kr", b: "700 000–1 200 000 kr" },
    ],
    aStrengths: [
      "Mer verkstadsvänlig — enklare service",
      "Bättre finish och material­val i inredning",
      "Populär i norr — stark andrahands­marknad",
    ],
    bStrengths: [
      "Mer standardutrustning för priset",
      "Mercedes-chassi som premium­alternativ",
      "Enorm återförsäljar­nätverk i Europa",
    ],
    verdict:
      "I norra Sverige rekommenderar vi 866F — närhet till service på Rapido, stark andrahands­marknad och färre problem med reservdelar.",
    faq: [
      {
        q: "Vilken har bäst isolering för vinterbruk?",
        a: "Marginellt Rapido 866F tack vare 35 mm väggisolering + dubbla golv. Hymer använder samma dubbla golv men något tunnare vägg (30 mm). Skillnaden märks vid -20 °C och lägre.",
      },
    ],
  },
  {
    slug: "rapido-9005-dfh-vs-rapido-866f",
    aName: "Rapido 9005 DFH",
    bName: "Rapido 866F",
    aBrand: "Rapido",
    bBrand: "Rapido",
    category: "Halvintegrerad vs Integrerad",
    intro:
      "9005 DFH är Rapidos integrerade flaggskepp, 866F den populära halvintegrerade. Skillnaden är förarpartiet — integrerad bygger egen hytt, halvintegrerad behåller Fiats.",
    winner:
      "9005 DFH om budget tillåter och du bor 6+ månader per år i bilen. 866F om B-körkort är krav eller om budget är begränsad.",
    rows: [
      { label: "Längd", a: "898 cm", b: "749 cm" },
      { label: "Totalvikt", a: "4 500 kg (C1)", b: "3 500 kg (B)" },
      { label: "Körkort", a: "C1", b: "B" },
      { label: "Panoramaruta", a: "Ja — integrerad hytt", b: "Nej — Fiat-hytt" },
      { label: "Värme", a: "Alde vattenburen", b: "Truma / Alde" },
      { label: "Kylskåp", a: "175 l med frys", b: "138 l" },
      { label: "Garage", a: "Mycket stort — scooter", b: "Stort — cyklar+" },
      { label: "Pris ny", a: "Från 2 350 000 kr", b: "Från 1 550 000 kr" },
    ],
    aStrengths: [
      "Panoramaruta — bättre utsikt och ljus",
      "Alde-värme standard — jämn komfort",
      "Större garage, större kyl, större allt",
    ],
    bStrengths: [
      "B-körkort räcker — ingen extra körkortskostnad",
      "1,5 m kortare — parkerar var som helst",
      "800 000 kr billigare nytt",
    ],
    verdict:
      "För digitala nomader/året-runt-liv: 9005 DFH. För långresenärer 2–4 månader per år: 866F ger mer bang for the buck.",
    faq: [
      {
        q: "Är C1-utbildningen värd merkostnaden för 9005?",
        a: "C1 kostar 15 000–25 000 kr en gång. Prisskillnaden mellan 866F och 9005 är 800 000 kr — så själva körkortet är försumbart om du vill ha 9005:s komfort.",
      },
    ],
  },
  {
    slug: "rapido-vs-hymer",
    aName: "Rapido",
    bName: "Hymer",
    aBrand: "Rapido",
    bBrand: "Hymer",
    category: "Tillverkare",
    intro:
      "Rapido och Hymer är två av Europas mest respekterade husbils­tillverkare — franskt hantverk mot tysk ingenjörskonst. Båda i premiumsegmentet.",
    winner:
      "Rapido för finish och design­detaljer. Hymer för teknik­robusthet och volym­fördelar.",
    rows: [
      { label: "Grundat", a: "1961, Frankrike", b: "1957, Tyskland" },
      { label: "Segment", a: "Premium plåt + halv + integrerad", b: "Premium hela sortimentet" },
      { label: "Årlig produktion", a: "Ca 8 000 husbilar", b: "Ca 25 000 husbilar" },
      { label: "Design­filosofi", a: "Fransk elegans, ljusa material", b: "Tysk funktion, mörka material" },
      { label: "Isolering", a: "35–45 mm PU/XPS", b: "35–45 mm XPS" },
      { label: "Vanligaste värme", a: "Alde / Truma diesel", b: "Alde / Truma gas" },
      { label: "Återförsäljar­nät SE", a: "Ca 6 auktoriserade", b: "Ca 12 auktoriserade" },
      { label: "Värdeminskning år 5", a: "40–50%", b: "40–50%" },
    ],
    aStrengths: [
      "Mer designade interiörer",
      "Populär i Frankrike/Spanien — bra för säsongsresor söderut",
      "Bättre bygg­kvalitet på detaljer (lådor, gångjärn, ljus)",
    ],
    bStrengths: [
      "Mer teknisk kompetens och R&D-budget",
      "Tätare service­nät",
      "Fler modeller att välja mellan",
    ],
    verdict:
      "På norrländska breddgrader väljer vi Rapido — bättre isolering, dieselvärme som stark katalog och stark andrahands­marknad hos aktiva förare.",
    faq: [
      {
        q: "Vilken har bäst service i Sverige?",
        a: "Hymer har fler auktoriserade återförsäljare rent numerärt. Rapido har färre men mer specialiserade — vi på AK Husbil i Kalix täcker hela Norrland som officiell Rapido-återförsäljare.",
      },
      {
        q: "Vilken håller värdet bäst?",
        a: "Ungefär lika. Skicket och service­historiken avgör mer än märket efter 3–5 år. Båda ligger ca 50–60% av nypris efter 5 år.",
      },
    ],
  },
  {
    slug: "rapido-vs-burstner",
    aName: "Rapido",
    bName: "Bürstner",
    aBrand: "Rapido",
    bBrand: "Bürstner",
    category: "Tillverkare",
    intro:
      "Rapido och Bürstner är båda europeiska husbils­tillverkare i mellan/premium­segmentet — franskt fokus på design mot tysk ingenjörskonst med bredare modell­utbud.",
    winner:
      "Rapido för långsiktig värde­hållning och finish. Bürstner om priset styr och du vill ha fler alternativ.",
    rows: [
      { label: "Grundat", a: "1961, Frankrike", b: "1958, Tyskland" },
      { label: "Ägare", a: "Trigano-koncernen", b: "Erwin Hymer Group" },
      { label: "Prissegment", a: "Mid-premium till premium", b: "Entry till premium (breddare)" },
      { label: "Isolering plåt", a: "35 mm+", b: "25–30 mm" },
      { label: "Standard­värme", a: "Truma Combi (gas/diesel)", b: "Truma Combi (gas)" },
      { label: "Fokus", a: "Långresor, vinterbruk", b: "Sommarcamping, familj" },
      { label: "Pris intro", a: "Från 950 000 kr", b: "Från 650 000 kr" },
    ],
    aStrengths: [
      "Bättre isolering för nordiskt klimat",
      "Dieselvärme som vanligt tillval",
      "Håller värdet lite bättre begagnat",
    ],
    bStrengths: [
      "Billigare inträdespris",
      "Fler entry-modeller att välja mellan",
      "Bredare familje-planlösningar",
    ],
    verdict:
      "För norrländska förhållanden: Rapido. För priskänslig familj eller sommarcamping i Sverige/Danmark: Bürstner.",
    faq: [
      {
        q: "Är Bürstner en okej vinterhusbil?",
        a: "Bürstners premium­serier (Elegance, Delfin) är byggda för vinter. Entry- och mellanserierna är främst sommarbilar och blir kalla under -10 °C.",
      },
    ],
  },
  {
    slug: "halvintegrerad-vs-integrerad",
    aName: "Halvintegrerad husbil",
    bName: "Integrerad husbil",
    aBrand: "Typ",
    bBrand: "Typ",
    category: "Karosstyp",
    intro:
      "Halvintegrerad behåller chassitillverkarens hytt (Fiat, Citroën, Ford). Integrerad har egen­byggd förar­hytt med panoramaruta. Skillnaden är märkbar i komfort, pris och köregenskaper.",
    winner:
      "Halvintegrerad för B-körkort och kortare bil. Integrerad för max komfort och året-runt-boende.",
    rows: [
      { label: "Typisk längd", a: "6,5–8 m", b: "7,5–9 m" },
      { label: "Typisk totalvikt", a: "3 500–4 500 kg", b: "4 500–5 500 kg" },
      { label: "Körkort oftast", a: "B (upp till 3 500 kg)", b: "C1 (upp till 7 500 kg)" },
      { label: "Panoramaruta", a: "Nej", b: "Ja" },
      { label: "Isolering fram", a: "Fiats standardhytt", b: "Byggd av tillverkaren – bättre" },
      { label: "Ljudnivå motorväg", a: "Bra", b: "Bäst" },
      { label: "Pris ny (typiskt)", a: "1,2–1,8 M kr", b: "2–3 M kr" },
    ],
    aStrengths: [
      "B-körkort räcker på de flesta",
      "800 000 kr billigare typiskt",
      "Enklare att sälja begagnat (större kundgrupp)",
    ],
    bStrengths: [
      "Panoramaruta ger enorm ljusinsläpp",
      "Bättre isolering fram — varmare vintertid",
      "Tystare gång på motorväg",
    ],
    verdict:
      "80% av alla svenska husbils­köpare landar på halvintegrerad — bäst kompromiss. Integrerad är för dig som bor 6+ månader per år eller kräver max komfort.",
    faq: [
      {
        q: "Kan man ha integrerad utan C1?",
        a: "Ja, men få — Rapido C56 t.ex. är integrerad på 3 500 kg. Priset blir dock högre per kg lastkapacitet.",
      },
    ],
  },
  {
    slug: "plathusbil-vs-halvintegrerad",
    aName: "Plåthusbil (van)",
    bName: "Halvintegrerad husbil",
    aBrand: "Typ",
    bBrand: "Typ",
    category: "Karosstyp",
    intro:
      "Plåthusbilen är förlängd skåpbil med inredning i det befintliga skalet. Halvintegrerad är byggt bredare hus ovanpå Fiat-hytten. Val styr av storlek­sbehov och parkerings­förhållanden.",
    winner:
      "Plåthusbil för par, stadsboende, wildcamping. Halvintegrerad för långresor, familj eller vinterbruk.",
    rows: [
      { label: "Typisk längd", a: "5,4–6,4 m", b: "6,5–8 m" },
      { label: "Typisk bredd", a: "205 cm", b: "230–235 cm" },
      { label: "Typisk höjd", a: "258–265 cm", b: "285–295 cm" },
      { label: "Bränsleförbrukning", a: "0,9–1,2 l/mil", b: "1,1–1,5 l/mil" },
      { label: "Isolering", a: "Standard (plåtskal)", b: "Bättre (sandwich)" },
      { label: "Boyta", a: "Kompakt", b: "50–70% mer" },
      { label: "Parkering", a: "Överallt", b: "Kräver planering" },
    ],
    aStrengths: [
      "Parkerar var som helst — även stadskärnor",
      "Lägre bränsleförbrukning",
      "Går in i vanliga parkeringshus (2,58 m höjd)",
    ],
    bStrengths: [
      "50–70% mer boyta för samma längd",
      "Bättre isolering och tystare",
      "Riktigt kök, större våtrum, större kyl",
    ],
    verdict:
      "Par under 40 år som gör mycket helgcamping: plåthusbil. Par som bor 3+ månader per år, familj eller vinter­resenärer: halvintegrerad.",
    faq: [
      {
        q: "Kan plåthusbil användas hela vintern?",
        a: "Ja, men med kompromisser — bilen blir kall snabbt när värmen är av, avloppet kan frysa utan dubbla golv. Halvintegrerad med dubbla golv är klart bättre vinterhusbil.",
      },
    ],
  },
  {
    slug: "rapido-vs-adria",
    aName: "Rapido",
    bName: "Adria",
    aBrand: "Rapido",
    bBrand: "Adria",
    category: "Tillverkare",
    intro:
      "Rapido är franskt premium; Adria är slovensk kvalitet till mer överkomligt pris. Båda populära i Skandinavien men riktar sig till olika köpare.",
    winner:
      "Rapido för premium­finish och långsiktigt värde. Adria för priskänsliga och bredare modell­utbud.",
    rows: [
      { label: "Grundat", a: "1961, Frankrike", b: "1965, Slovenien" },
      { label: "Prissegment", a: "Premium", b: "Mid" },
      { label: "Modellutbud", a: "Fokuserat premium­utbud", b: "Bredare från entry till premium" },
      { label: "Isolering typ", a: "35 mm+ PU sandwich", b: "25–30 mm XPS" },
      { label: "Standard­värme", a: "Truma Combi", b: "Truma Combi" },
      { label: "Vinterprestanda", a: "Utmärkt (dubbla golv)", b: "OK (Alpine­serien bättre)" },
      { label: "Pris ny", a: "Från 950 000 kr", b: "Från 650 000 kr" },
      { label: "Värdeminskning 5 år", a: "40–50%", b: "50–60%" },
    ],
    aStrengths: [
      "Bättre isolering och bygg­kvalitet",
      "Håller värdet betydligt bättre",
      "Perfekt för nordiskt klimat",
    ],
    bStrengths: [
      "300 000 kr billigare typiskt",
      "Fler modeller att välja mellan",
      "Enklare och billigare service",
    ],
    verdict:
      "På 10 års sikt är Rapido oftast billigare per körd km tack vare bättre värde­hållning — men startkapitalet är högre. Adria för dig som byter bil oftare.",
    faq: [
      {
        q: "Är Adria en dålig husbil?",
        a: "Nej — Adria är fullt godtagbar kvalitet i sitt prisintervall. Men det är inte samma bygg­standard som Rapido/Hymer, så för nordiskt vinterbruk och långresor rekommenderar vi Rapido.",
      },
    ],
  },
  {
    slug: "husbil-vs-husvagn",
    aName: "Husbil",
    bName: "Husvagn",
    aBrand: "Typ",
    bBrand: "Typ",
    category: "Fordonstyp",
    intro:
      "Klassiska valet: köra bilen som är inredd (husbil) eller dra en inredd vagn efter bilen (husvagn). Ekonomi, körvana och användnings­mönster styr valet.",
    winner:
      "Husbil för dig som gillar att röra på dig ofta. Husvagn för dig som slår läger länge på samma plats.",
    rows: [
      { label: "Startpris", a: "550 000 kr", b: "200 000 kr" },
      { label: "Dragbil behövs", a: "Nej", b: "Ja (minst 1 800 kg dragvikt)" },
      { label: "Rörlighet på plats", a: "Måste dras med, allt lossas", b: "Bilen finns fri på camping" },
      { label: "Bränsle långresa", a: "1,0–1,5 l/mil (allt-i-ett)", b: "Bilen förbrukar +30–50%" },
      { label: "Förvaring vintern", a: "50 000–200 000 kr", b: "Enklare, ryms i garage/tomt" },
      { label: "Värdeminskning år 1", a: "15–20%", b: "10–15%" },
      { label: "Vinterbruk", a: "Enklare att flytta", b: "Frusna hjul, tyngre att dra" },
    ],
    aStrengths: [
      "Ingen dragbil krävs",
      "Enklare att flytta — kör bara",
      "Bättre för långresor och roundtrip",
    ],
    bStrengths: [
      "Halva kostnaden av jämförbar husbil",
      "Bilen finns fri på camping — kör ut och handla",
      "Enklare värdeminskning",
    ],
    verdict:
      "Om ni gillar att röra på er varannan dag: husbil. Om ni står 1–2 veckor per plats och vill ha bilen fri: husvagn. Ekonomi säger husvagn — flexibilitet säger husbil.",
    faq: [
      {
        q: "Vad är billigast över 10 år?",
        a: "Husvagn — lägre inköp, lägre värdeminskning och du drar bara den vid resa. Men den kräver att du redan har passande dragbil.",
      },
      {
        q: "Vilken är bäst för familj med barn?",
        a: "Husbil om ni ska röra er mycket (barnen sitter fastspända bak, allt är med). Husvagn om ni ska slå läger 1–3 veckor per plats — bilen tar sedan familjen till stranden/utflykter.",
      },
    ],
  },
  {
    slug: "rapido-v62-vs-hymer-free",
    aName: "Rapido V62",
    bName: "Hymer Free",
    aBrand: "Rapido",
    bBrand: "Hymer",
    category: "Plåthusbil",
    intro:
      "Två premium­plåthusbilar för par — Rapido V62 med franskt finish, Hymer Free med tysk teknik och Mercedes-Sprinter-chassi som tillval.",
    winner:
      "Rapido V62 för traditionell husbils­känsla. Hymer Free för dig som föredrar Mercedes-chassi.",
    rows: [
      { label: "Längd", a: "640 cm", b: "540–636 cm" },
      { label: "Bredd", a: "205 cm", b: "204 cm" },
      { label: "Chassi", a: "Fiat Ducato", b: "Fiat / Mercedes Sprinter (option)" },
      { label: "Isolering", a: "35 mm PU + XPS", b: "30 mm XPS" },
      { label: "Kök", a: "3-låga, 90–133 l", b: "2-låga, 84 l" },
      { label: "Pris ny (Fiat)", a: "Från 1 150 000 kr", b: "Från 1 050 000 kr" },
      { label: "Pris ny (Merc)", a: "—", b: "Från 1 350 000 kr" },
    ],
    aStrengths: [
      "Större kök (3-låga)",
      "Bättre isolering för vinter",
      "Etablerad andrahands­marknad",
    ],
    bStrengths: [
      "Mercedes-chassi som premium­alternativ",
      "Nyare planlösnings­koncept",
      "Något billigare på Fiat­varianten",
    ],
    verdict:
      "För norrländska förhållanden och långresor: Rapido V62. För dig som vill ha Mercedes-drift och accepterar högre pris: Hymer Free.",
    faq: [
      {
        q: "Är Mercedes-chassit värt merkostnaden?",
        a: "Endast om du planerar 20 000+ mil/år eller vill ha 4x4. För vanlig svensk husbils­användning (5 000–15 000 km/år) räcker Fiat och sparar 300 000 kr.",
      },
    ],
  },
  {
    slug: "truma-vs-alde",
    aName: "Truma Combi (varmluft)",
    bName: "Alde (vattenburen)",
    aBrand: "Värme",
    bBrand: "Värme",
    category: "Värmesystem",
    intro:
      "Två helt olika värmesystem — Truma blåser varmluft via kanaler; Alde cirkulerar varmt vatten i radiatorer. Val påverkar komfort, ekonomi och underhåll.",
    winner:
      "Truma om priset styr och du campar sommartid. Alde om du vill ha jämn premium­värme året runt.",
    rows: [
      { label: "Ursprung", a: "Tyskland, 1961", b: "Sverige (Halmstad), 1959" },
      { label: "Princip", a: "Fläkt + varmluftskanaler", b: "Cirkulerande vatten + radiatorer" },
      { label: "Uppvärmnings­tid från kall", a: "20–30 min", b: "45–60 min" },
      { label: "Jämnhet i bilen", a: "Varmt vid ventil, kallt bort", b: "Jämnt hela bilen" },
      { label: "Luftfuktighet", a: "Torr luft — dammspridning", b: "Fuktbevarande — behagligare" },
      { label: "Ljudnivå", a: "Hörbar fläkt", b: "Nästan ljudlös" },
      { label: "Merkostnad", a: "Standard på de flesta", b: "40 000–60 000 kr tillval" },
      { label: "Servicekostnad", a: "Låg", b: "Medel–hög (glykol byte)" },
    ],
    aStrengths: [
      "Snabb uppvärmning från kall bil",
      "Låg inköpskostnad — standard",
      "Enkelt att serva",
    ],
    bStrengths: [
      "Jämn temperatur i hela bilen",
      "Ingen fläkt-ljud",
      "Torr luft-problem försvinner",
    ],
    verdict:
      "För plåthusbil: Truma räcker gott. För halv/integrerad som ska bo lång tid vintertid: Alde är värt merkostnaden.",
    faq: [
      {
        q: "Kan man byta från Truma till Alde i efterhand?",
        a: "Ja, men kostsamt — 80 000–150 000 kr inklusive installation. Oftast inte lönt om bilen inte är väldigt ny.",
      },
    ],
  },
  {
    slug: "litium-vs-agm-batteri",
    aName: "Litiumbatteri (LiFePO4)",
    bName: "AGM-batteri",
    aBrand: "Batteri",
    bBrand: "Batteri",
    category: "Bostadsbatteri",
    intro:
      "Litium (LiFePO4) håller på att ersätta AGM som standard i husbil. Skillnaden i användbar kapacitet, vikt och livslängd är dramatisk.",
    winner: "Litium om du inte kör helt sommar­campare på ny bil. AGM räcker för lägsta budget.",
    rows: [
      { label: "Användbar kapacitet", a: "90% av angiven", b: "50% av angiven" },
      { label: "Vikt per 100 Ah", a: "12–15 kg", b: "28–32 kg" },
      { label: "Livslängd (cykler)", a: "3 000–5 000", b: "300–500" },
      { label: "Livstid", a: "10+ år", b: "4–6 år" },
      { label: "Laddningstid", a: "Snabb (upp till 1C)", b: "Långsam (0,2C)" },
      { label: "Tål djupurladdning", a: "Ja", b: "Nej — skador" },
      { label: "Pris per 100 Ah", a: "8 000–12 000 kr", b: "2 500–4 000 kr" },
      { label: "Kostnad per Wh över livstid", a: "Lägst", b: "3x litium" },
    ],
    aStrengths: [
      "Nästan dubbel användbar ström",
      "En tredjedel av vikten",
      "Tål off-grid boende utan förkortad livstid",
    ],
    bStrengths: [
      "Lägsta inköpspris",
      "Beprövad teknik — 30+ års data",
      "Enklare byte (samma kontakter)",
    ],
    verdict:
      "Litium betalar av sig på 5–8 år vid regelbunden användning. På sikt är AGM dyrare. Undantag: sällan­förare som byter bil vart 3:e år.",
    faq: [
      {
        q: "Kan man byta AGM mot litium i befintlig husbil?",
        a: "Ja, men kolla laddregulator och laddare — de behöver klara litium (LiFePO4-profil). Kostnad total 12 000–25 000 kr inklusive nya komponenter.",
      },
    ],
  },
];

export const COMPARISON_SLUGS = COMPARISONS.map((c) => c.slug);
export function getComparison(slug: string): Comparison | undefined {
  return COMPARISONS.find((c) => c.slug === slug);
}
